import { SECTION_PARAM_KEY } from "./sectionParam";

interface DrawerOpenArgs {
  pathname: string;
  search: string;
  /** The manifest drawer's currently-open id, if any (a path segment). */
  currentManifestId: string | undefined;
}

/**
 * Drops the currently-open manifest id (and any deeper optional segment
 * after it, e.g. a line-item id) from the path, mirroring
 * `useSelectedIdInUrl`'s own truncation.
 */
function pathWithoutManifestSegment(
  pathname: string,
  currentManifestId: string | undefined
): string[] {
  const segments = pathname.split("/").filter(Boolean);
  if (currentManifestId) {
    const idx = segments.lastIndexOf(currentManifestId);
    if (idx >= 0) {
      segments.length = idx;
    }
  }
  return segments;
}

/** Builds the path+search for opening a manifest's drawer from `ManifestsV3`. */
export function buildManifestOpenPath(
  args: DrawerOpenArgs & { manifestId: string; section?: string }
): string {
  const { pathname, search, currentManifestId, manifestId, section } = args;
  const segments = pathWithoutManifestSegment(pathname, currentManifestId);
  const params = new URLSearchParams(search);
  // The one-shot `?section=` deep link the drawer consumes on mount, so a
  // caller that opened the drawer to act on something specific lands on it
  // rather than at the top of a long drawer.
  if (section) params.set(SECTION_PARAM_KEY, section);
  const query = params.toString();
  return `/${[...segments, manifestId].join("/")}${query ? `?${query}` : ""}`;
}
